<!-- eslint-disable max-len -->
<template>
  <div>
    <v-row no-gutters>
      <v-col
        :cols="12"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
        class="center-card mx-auto pt-3 py-3 pr-3 pl-3"
      >
        <v-card class="text-center" style="width: 100%;">
          <v-card-title class="title-bg">
            <v-row class="pt-3 pb-3 pr-3 pl-3">
              <div style="font-size: 18px;color: white;font-weight: 500;text-align: left;">
                ระบบการแจ้งเหตุจำเป็นที่ไม่อาจไปใช้สิทธิเลือกตั้งทางอิเล็กทรอนิกส์
              </div>
              <div style="font-size: 18px;color: white;font-weight: 500;text-align: left;">
                การเลือกตั้งสมาชิกสภาผู้แทนราษฎร
              </div>
            </v-row>
          </v-card-title>
          <v-row no-gutters class="pr-3 pl-3 pt-2">
            <div class="labelmain pt-0">
              กรุณากรอกข้อมูลของท่านให้ถูกต้องครบถ้วน
            </div>
          </v-row>
          <v-row no-gutters class="pr-3 pl-3 pt-3">
            <div class="labelmain labelinfo" style="text-align: left;">
              เลขประจำตัวประชาชน
            </div>
          </v-row>
          <v-row no-gutters class="pr-3 pl-3">
            <textField
              v-model="pid"
              mask="#-####-#####-##-#"
              placeholder="0-0000-00000-00-0"
              class="mt-0 pt-0"
            />
          </v-row>
          <v-row no-gutters class="pr-3 pl-3 pt-3">
            <div class="labelmain labelinfo" style="text-align: left;">
              เลขรหัสกำกับบัตร (เลขหลังบัตรประจำตัวประชาชน)
            </div>
            <div
              class="material-icons mt-0"
              style="cursor: pointer;font-size: 20px; padding-top: 7px;color: gray;"
              @click="exDialog = true"
            >
              help
            </div>
          </v-row>
          <v-row no-gutters class="pr-3 pl-3">
            <textField
              v-model="laserid"
              mask="AA#-#######-##"
              placeholder="AA0-0000000-00"
              class="mt-0 pt-0"
            />
          </v-row>
          <v-row no-gutters class="pr-3 pl-3 pt-3">
            <div class="labelmain labelinfo" style="text-align: left;">
              ชื่อ *ไม่ต้องระบุคำนำหน้าชื่อ (เช่น นาย, นาง, นางสาว)
            </div>
          </v-row>
          <v-row no-gutters class="pr-3 pl-3">
            <textFieldName
              v-model="fname"
              placeholder="ชื่อภาษาไทย"
              :maxlength="70"
              class="mt-0 pt-0"
              @keydown.native="keyFilter($event, 'th')"
              @keydown="changeFocus('lname')"
            />
          </v-row>
          <v-row no-gutters class="pr-3 pl-3 pt-1">
            <textFieldName
              id="lname"
              v-model="lname"
              placeholder="นามสกุลภาษาไทย"
              :maxlength="70"
              class="mt-0 pt-0"
              @keydown.native="keyFilter($event, 'th')"
            />
          </v-row>
          <v-row no-gutters class="pr-3 pl-3 pt-3">
            <div class="labelmain labelinfo" style="text-align: left;">
              วันเดือนปีเกิดที่ปรากฏในบัตรประชาชน
            </div>
          </v-row>
          <v-row no-gutters class="pr-3 pl-3">
            <v-col
              cols="3"
              class="px-0 pt-0  pb-0 pr-2"
            >
              <v-autocomplete
                v-model="day"
                label="วันที่"
                :items="listDay"
                item-text="desc"
                item-value="code"
                :background-color="'tileMobile'"
                hide-details solo flat dense
              />
            </v-col>
            <v-col
              cols="5"
              class="px-0 pt-0  pb-0 pr-2"
            >
              <v-autocomplete
                v-model="month"
                label="เดือน"
                :items="listMonth"
                item-text="desc"
                item-value="code"
                hide-details solo flat dense
                :background-color="'tileMobile'"
                @change="chgMonth()"
              />
            </v-col>
            <v-col
              cols="4"
              class="px-0 pt-0 pb-0"
            >
              <v-autocomplete
                v-model="year"
                label="ปี พ.ศ."
                :items="listYear"
                hide-details solo flat dense
                :background-color="'tileMobile'"
                @change="chgMonth()"
              />
            </v-col>
          </v-row>
          <v-row v-show="showRecaptcha" no-gutters class="justify-content-center pt-3">
            <vue-recaptcha
              ref="invisibleRecaptcha"
              size="invisible"
              :sitekey="sitekey"
              :load-recaptcha-script="true"
              @verify="callAuthen"
            />
          </v-row>
          <v-row no-gutters class="pr-3 pl-3 pt-3">
            <v-btn style="width:100%;" color="primary" @click="onClick()">
              <span class="material-icons">
                search
              </span>
              <div style="font-size: 16px;font-weight: 500;">
                ตรวจสอบข้อมูล
              </div>
            </v-btn>
          </v-row>
          <v-row no-gutters class="justify-end pl-3 pr-3">
            <div class="labelmain">
              V 1.1.2
            </div>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col
        :cols="12"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
        class="center-card mx-auto pt-1 py-3 pr-3 pl-3"
      >
        <div style="background-color: #D8D8D8;border-radius: 10px;width: 100%;">
          <v-col
            :cols="12"
            :sm="12"
            :md="12"
            :lg="8"
            :xl="8"
          >
            <v-row no-gutters class="pr-3 pl-3 pt-3">
              <div class="labelmain labelinfo" style="text-align: left;color: #373877; font-weight: 600;">
                คำแนะนำ การแจ้งเหตุจำเป็นไม่อาจไปใช้สิทธิเลือกตั้ง ทางอิเล็กทรอนิกส์
              </div>
            </v-row>
            <v-row no-gutters class="pr-3 pl-3">
              <div class="labelmain labelinfo" style="text-align: left;color: #373877;">
                1. เป็นผู้มีชื่ออยู่ในบัญชีผู้มีสิทธิเลือกตั้งของการเลือกตั้งแต่ละประเภทการเลือกตั้ง
              </div>
            </v-row>
            <v-row no-gutters class="pr-3 pl-3">
              <div class="labelmain labelinfo" style="text-align: left;color: #373877;">
                2. ต้องแจ้งเหตุในช่วงระยะเวลาที่กำหนด
              </div>
            </v-row>
            <v-row no-gutters class="pr-3 pl-3">
              <div class="labelmain labelinfo" style="text-align: left;color: #373877;padding-left:2%;">
                2.1 ก่อนการเลือกตั้ง 7 วัน
              </div>
            </v-row>
            <v-row no-gutters class="pr-3 pl-3 pb-3">
              <div class="labelmain labelinfo" style="text-align: left;color: #373877;padding-left:2%;">
                2.2 หรือภายใน 7 วันนับแต่วันเลือกตั้ง
              </div>
            </v-row>
          </v-col>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="exDialog" max-width="400px">
      <v-card class="card">
        <v-img :src="imageUrl" contain />
        <v-row class="pt-3 pb-3 pl-3 pr-3">
          <v-spacer />
          <v-btn color="red" style="text-align: right;float: right;color: white;width: 100%;" @click="exDialog = false">
            <div
              class="material-icons pt-0"
              style="cursor: pointer;font-size: 24px; padding-top: 7px;color: white;"
              @click="exDialog = true"
            >
              close
            </div>
            <div style="font-size: 20px;">
              ปิด
            </div>
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isProcess"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text class="pt-3">
          กรุณารอสักครู่...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import get from 'lodash.get'
import { mapState, mapActions } from 'vuex'
import { VueRecaptcha } from 'vue-recaptcha'
import moment from 'moment'
import digit, { DigitType } from '@cdglib/js-moi-xid'
import Swal from 'sweetalert2'
import keyFilter from '../../store/modules/functions/keyFilter'
import func from '../../store/modules/functions/commonFunction'
import textField from '../../components/textField.vue'
import textFieldName from '../../components/nameField.vue'
import api from '../../store/modules/api/api'
import image from '../../assets/lasersam.jpg'

export default {
  components: {
    VueRecaptcha, textField, textFieldName,
  },
  data() {
    return {
      keyFilter,
      isProcess: false,
      pid: '',
      fname: '',
      lname: '',
      laserid: '',
      showRecaptcha: true,
      sitekey: '6LfQ3dQlAAAAAECDy3CjXpWyzpUDcBPB4w6Pw2Ap',
      listYear: [],
      listMonth: [],
      listDay: [],
      day: null,
      month: null,
      year: null,
      imageUrl: image,
      exDialog: false,

    }
  },
  computed: {
    ...mapState({
      selData: state => state.dataStore,
      token: state => state.regisStore.token,
    }),
    breakpoint() {
      return get(this.$vuetify, 'breakpoint', {})
    },
  },
  created() {
    moment.locale('th')
    const currentDate = moment().add(543, 'year').format('YYYYMMDD')
    // eslint-disable-next-line no-plusplus
    for (let i = 2400; i <= Number(currentDate.substring(0, 4)); i++) {
      this.listYear.push(i.toString())
    }
    this.listYear.reverse()
    this.listMonth = this.fetchMonth()
    this.listDay = [{
      code: '00',
      desc: 'ไม่ทราบวันเกิด',
    }]
    // eslint-disable-next-line no-plusplus
    for (let j = 1; j <= 31; j++) {
      this.listDay.push({
        code: this.pad(j, 2),
        desc: j,
      })
    }
    this.listDay.sort((a, b) => a.code - b.code)
  },
  methods: {
    ...mapActions({
      setEledate: 'regisStore/setEledate',
      setMark: 'regisStore/setMark',
      setPid: 'regisStore/setPid',
      setToken: 'regisStore/setToken',
      setDisplay: 'regisStore/setDisplay',
      setListEledate: 'dataStore/setListEledate',
      setListMark: 'dataStore/setListMark',
    }),
    descMark(text) {
      let result = 'สิทธิเลือกสมาชิกสภาผู้แทนราษฎร'
      if (text.split('#')[1] === '1') result += ('อนุมัติแล้ว')
      return result
    },
    checkUI() {
      const pid = this.pid.replace(/-/g, '')
      const laserid = this.laserid.replace(/-/g, '')
      // PID
      if (func.nullFormat(pid)) {
        Swal.fire({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาระบุเลขประจำตัวประชาชน',
          confirmButtonText: 'ปิด',
        })
        return false
      }
      if (func.lengthFormat(pid, 13)) {
        Swal.fire({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาระบุเลขประจำตัวประชาชนให้ครบ',
          confirmButtonText: 'ปิด',
        })
        return false
      }
      if (!digit.checkDigit(pid, DigitType.PID)) {
        Swal.fire({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาระบุเลขประจำตัวประชนให้ถูกต้อง',
          confirmButtonText: 'ปิด',
        })
        return false
      }
      // LASER ID
      if (func.nullFormat(laserid)) {
        Swal.fire({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาระบุเลขหลังบัตรประจำตัวประชาชน',
          confirmButtonText: 'ปิด',
        })
        return false
      }
      if (func.lengthFormat(laserid, 12)) {
        Swal.fire({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาระบุเลขหลังบัตรประจำตัวประชาชนให้ครบ',
          confirmButtonText: 'ปิด',
        })
        return false
      }
      // FNAME LNAME
      if (func.nullFormat(this.fname)) {
        Swal.fire({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาระบุชื่อต้น',
          confirmButtonText: 'ปิด',
        })
        return false
      }
      if (func.nullFormat(this.lname)) {
        Swal.fire({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาระบุนามสกุล',
          confirmButtonText: 'ปิด',
        })
        return false
      }

      if (!this.day || !this.month || !this.year) {
        Swal.fire({
          icon: 'warning',
          title: 'แจ้งเตือน',
          text: 'กรุณาระบุวันเดือนปีเกิด',
          confirmButtonText: 'ปิด',
        })
        return false
      }
      return true
    },
    changeFocus(id) {
      document.getElementById(id).focus()
    },
    async onClick() {
      if (!this.checkUI()) return false
      this.$refs.invisibleRecaptcha.execute()
    },
    async callAuthen(response) {
      await this.$refs.invisibleRecaptcha.reset()

      this.isProcess = true
      await this.verified(response)
    },
    async verified(token) {
      const pid = this.pid.replace(/-/g, '')
      const laserid = this.laserid.replace(/-/g, '')
      const dob = this.year.toString() + this.month + this.day

      const googleResponseToken = token
      this.isProcess = true
      try {
        // eslint-disable-next-line max-len
        const authen = await api.apiEledate(pid, laserid, this.fname.trim(), this.lname.trim(), dob, googleResponseToken)
        if (authen.success) {
          this.setToken(authen.access_token)
          this.setUpData(pid, authen)
        } else {
          this.isProcess = false
          Swal.fire({
            icon: 'warning',
            title: 'แจ้งเตือน',
            text: 'ข้อมูลที่ระบุไม่ถูกต้อง',
            confirmButtonText: 'ปิด',
          })
          return false
        }
      } catch (error) {
        const errordesc = (error.response.data.info) ? error.response.data.info : 'เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง'
        this.isProcess = false
        Swal.fire({
          icon: 'error',
          title: 'แจ้งเตือน',
          text: errordesc,
          confirmButtonText: 'ปิด',
        })
      }
    },
    async setUpData(pid, authen) {
      await this.setPid(pid)
      const getDate = authen.eledate
      this.setDisplay(authen.display_date)
      await this.initData(getDate)
    },
    async initData(eledate) {
      if (eledate.length > 1) {
        await this.setListEledate(eledate)
        this.isProcess = false
        this.$router.push('/election/abscausess/pick')
      } else {
        await this.setEledate(eledate[0])
        try {
          const getMark = await api.apiget(this.token, eledate[0].eletype, eledate[0].eledate)
          const flagOfficer = await this.checkFlag(getMark)
          if (getMark[0].ntInfflag === 1) {
            this.isProcess = false
            Swal.fire({
              icon: 'success',
              title: 'อนุมัติ',
              text: 'การแจ้งเหตุได้รับการอนุมัติแล้ว',
              confirmButtonText: 'ปิด',
            })
            return false
          }
          if (flagOfficer > 0) {
            this.isProcess = false
            Swal.fire({
              icon: 'success',
              title: 'แจ้งเตือน',
              text: 'เป็นเจ้าหน้าที่ใช้สิทธิ ต่างเขต / ต่างหน่วย',
              confirmButtonText: 'ปิด',
            })
            return false
          }
          this.isProcess = false
          await this.setListMark(getMark)
          const temp = await this.markProcess()
          await this.setMark(temp.value)
          this.$router.push('/election/abscausess/rep')
        } catch (error) {
          let erricon = 'error'
          let errdesc = 'เกิดข้อผิดพลาดที่เครื่องเซิฟเวอร์'
          this.isProcess = false
          if (error.response.status === 404 && error.response.data.info !== undefined) {
            erricon = 'warning'
            errdesc = error.response.data.info
          }
          Swal.fire({
            icon: erricon,
            title: 'แจ้งเตือน',
            text: errdesc,
            confirmButtonText: 'ปิด',
          })
          return false
        }
      }
    },
    markProcess() {
      return {
        text: this.descMark(`${this.selData.data.mark[0].ntMark2}#${this.selData.data.mark[0].ntInfflag}`),
        value: `${this.selData.data.mark[0].ntMark2}#${this.selData.data.mark[0].ntStatus}#${this.selData.data.mark[0].ntInfflag}`,
      }
    },
    checkFlag(arr) {
      let flag = 0
      if (arr[0].absInfflag === 3 || arr[0].absInfflag === 4) {
        arr.forEach(element => {
          flag += element.ntStatus
        })
        if (flag > 0) return 1
      }
      return 0
    },
    pad(number, width) {
      // eslint-disable-next-line no-param-reassign
      width -= number.toString().length
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
      }
      return `${number}` // always return a string
    },
    getDay() {
      const monthDate = moment(`${this.year - 543}-${this.month}`, 'YYYY-MM')
      let daysInMonth = monthDate.daysInMonth()
      const arrDays = []
      while (daysInMonth) {
        const current = moment().date(daysInMonth)
        arrDays.push(current.format('DD'))
        // eslint-disable-next-line no-plusplus
        daysInMonth--
      }
      return arrDays
    },
    chgMonth() {
      let getListDay = []
      try {
        const currentDaySelect = this.day.toString()
        if (this.year !== null && this.month !== null && this.month !== 0) {
          getListDay = this.getDay()
          this.listDay = [
            {
              code: '00',
              desc: 'ไม่ทราบวันเกิด',
            },
          ]
          getListDay.forEach((x) => {
            this.listDay.push({
              code: this.pad(Number(x), 2),
              desc: Number(x),
            })
          })
        }

        const duplicateday = this.findDuplicateDay(this.listDay)
        if (duplicateday > 1) this.listDay.push({ desc: 31, code: '31' })
        this.listDay.sort((a, b) => a.code - b.code)
        const findDay = this.listDay.find((x) => x.code === currentDaySelect)

        if (findDay === undefined) {
          this.day = null
        } else {
          this.day = currentDaySelect
        }
      } catch (error) {
        //
      }
    },
    findDuplicateDay(arr) {
      let temparr = 0

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].desc === 1 && arr[i].code === '01') {
          temparr += 1
        }
      }

      return temparr
    },
    fetchMonth() {
      const month = [
        {
          code: '00',
          desc: 'ไม่ทราบเดือนเกิด',
        },
        {
          code: '01',
          desc: 'มกราคม',
        },
        {
          code: '02',
          desc: 'กุมภาพันธ์',
        },
        {
          code: '03',
          desc: 'มีนาคม',
        },
        {
          code: '04',
          desc: 'เมษายน',
        },
        {
          code: '05',
          desc: 'พฤษภาคม',
        },
        {
          code: '06',
          desc: 'มิถุนายน',
        },
        {
          code: '07',
          desc: 'กรกฎาคม',
        },
        {
          code: '08',
          desc: 'สิงหาคม',
        },
        {
          code: '09',
          desc: 'กันยายน',
        },
        {
          code: '10',
          desc: 'ตุลาคม',
        },
        {
          code: '11',
          desc: 'พฤศจิกายน',
        },
        {
          code: '12',
          desc: 'ธันวาคม',
        },
      ]
      return month
    },
  },
}
</script>

<style lang="sass" scoped>
.title-bg
  background-color: #373877

.center-card
  display: flex
  justify-content: center
  padding-top: 10px

.labelinfo
  color: #373877

.labelmain
  font-weight: 500
  padding-top: 5px
.justify-content-center
  align-items: center
  justify-content: center
.card
  max-height: calc(100vh - 64px)
  overflow-y: hidden
  overflow-x: hidden
</style>
